import type { StateCreator } from 'zustand'

export type FormatsSliceShape = {
	dateFormat: 'EU' | 'US'
	setDateFormat: (dateFormat: 'EU' | 'US') => void
}
export const createFormatsSlice: StateCreator<FormatsSliceShape> = (set) => ({
	dateFormat: 'EU',
	setDateFormat: (dateFormat) => set({ dateFormat }),
})
